// ies data from
// https://github.com/gkjohnson/three-gpu-pathtracer/blob/main/example/spotLights.js
export const IES_PROFILE_LM_63_1995 = `IESNA:LM-63-1995
[TEST] 
[MANUFAC] BEGA
[MORE] Copyright LUMCat V 
[LUMCAT] 
[LUMINAIRE] 50988.2K3
[LAMPCAT] LED  11,5W
[LAMP]    1218 lm,14 W
TILT=NONE
1 -1 1.0 37 1 1 2 -0.120 0.000 0.000
1.0 1.0 14
   0.0   2.5   5.0   7.5  10.0  12.5  15.0  17.5  20.0  22.5  25.0  27.5  30.0
  32.5  35.0  37.5  40.0  42.5  45.0  47.5  50.0  52.5  55.0  57.5  60.0  62.5
  65.0  67.5  70.0  72.5  75.0  77.5  80.0  82.5  85.0  87.5  90.0
   0.0
    2225.9    2154.6    1986.3    1758.9    1532.7    1342.4    1182.9    1045.2
     920.2     806.6     705.1     617.7     553.4     514.3     474.4     388.7
     249.2     118.9      46.3      30.3      26.5      24.5      23.0      21.8
      20.6      19.6      18.5      17.0      14.8      12.0       9.0       6.5
       4.3       2.5       1.2       0.4       0.0
`;
